export const sliderLabelStyle = (isOn: boolean | undefined) => ({
  borderColor: isOn ? '#2979FF' : undefined,
});

export const sliderButtonStyle = (isOn: boolean | undefined) => ({
  background: isOn ? '#2979FF' : undefined,
});
